import { elementsPackageI18nNamespaces } from '@elements-financial/elements';

export const allI18NNamespaces = [
  'acceptInvite',
  'accountDetails',
  'auth',
  'client',
  'clients',
  'editNotes',
  'error',
  'forAdvisor',
  'guides',
  'integrations',
  'invitations',
  'onePagePlan',
  'reports',
  'saod',
  'signIn',
  'taxes',
  'form',
  'settings',
  'dashboard',
  ...elementsPackageI18nNamespaces,
];
